import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment'
import { Button, TextInput, Table, TableHeader, TableLoading, Pagination, Colors, ContextMenu } from 'advenio-components'
import { Form } from 'formsy-react-2'
import DocumentsActions from '../../../Data/Redux/DocumentsRedux'
import DeleteConfirmationModal from '../../../Components/Documents/DeleteConfirmationModal'
import { BACK_OFFICE_CENTER_ROLES } from '../../../Constants'
import { userHasRole } from '../../../utils/Utils'

var Container = styled.div`
  padding: 24px 16px;
`

var HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

var Title = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #212B36;
`

var SearchRow = styled(Form)`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-bottom: 24px;
`

var InputWrapper = styled.div`
  width: 280px;
`

var SearchButton = styled.div`
  padding-bottom: 30px;
`

var TableContainer = styled.div`
  position: relative;
  z-index: 1;
`

var CellContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: normal;
  height: 55px;
  color: #637381;
  font-size: 14px;
  background-color: ${function (props) { return props.index % 2 ? Colors.gray200 : Colors.white300 }};
`

var LeftCell = styled(CellContainer)`
  justify-content: flex-start;
  padding-left: 14px;
`

var NoResults = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  color: #637381;
  font-size: 14px;
  background-color: #FFFFFF;
  border: 1px solid ${Colors.gray200};
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`

var PaginationContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`

class StudentDocumentRepository extends Component {
  constructor (props) {
    super(props)
    this.state = {
      search: '',
      page: 1,
      perPage: 20,
      deleteModalOpen: false,
      documentToDelete: null
    }
  }

  componentDidMount () {
    this.fetchDocuments()
  }

  fetchDocuments = () => {
    var filters = {
      page: this.state.page,
      per_page: this.state.perPage
    }
    if (this.state.search) {
      filters.search = this.state.search
    }
    this.props.fetchStudentDocuments(this.props.studentId, filters)
  }

  handleSearch = (formData) => {
    this.setState({ search: formData.search || '', page: 1 }, this.fetchDocuments)
  }

  handlePageClick = (page) => {
    this.setState({ page: page }, this.fetchDocuments)
  }

  openDeleteModal = (document) => {
    this.setState({ deleteModalOpen: true, documentToDelete: document })
  }

  closeDeleteModal = () => {
    this.setState({ deleteModalOpen: false, documentToDelete: null })
  }

  confirmDelete = () => {
    var doc = this.state.documentToDelete
    if (doc) {
      this.props.deleteDocument(this.props.studentId, doc.id)
    }
  }

  handleSendDocument = () => {
    this.props.openWizard(null, this.props.studentId)
  }

  handleDownload = (documentId) => {
    this.props.downloadDocument(this.props.studentId, documentId)
  }

  canDelete = () => {
    let { user } = this.props
    return userHasRole(user, BACK_OFFICE_CENTER_ROLES)
  }

  formatFileSize = (bytes) => {
    if (!bytes) return '0 B'
    var sizes = ['B', 'KB', 'MB', 'GB']
    var i = Math.floor(Math.log(bytes) / Math.log(1024))
    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i]
  }

  formatMimeType = (mime) => {
    if (!mime) return '-'
    if (mime === 'application/pdf') return 'PDF'
    if (mime.indexOf('word') > -1) return 'Word'
    if (mime.indexOf('excel') > -1 || mime.indexOf('spreadsheet') > -1) return 'Excel'
    if (mime.indexOf('powerpoint') > -1 || mime.indexOf('presentation') > -1) return 'PPT'
    if (mime.indexOf('image') > -1) return 'Imagen'
    if (mime === 'text/plain') return 'Texto'
    return '-'
  }

  renderTable = () => {
    var self = this
    var documents = this.props.documents
    var fetching = this.props.fetching
    var canDelete = this.canDelete()

    if (fetching) {
      return (
        <TableContainer>
          <TableLoading
            roundedCorners
            columns={[
              { id: 1, header: 'Nombre', element: 'Text' },
              { id: 2, header: 'Tipo', element: 'Text', width: '100px', center: true },
              { id: 3, header: 'Tamaño', element: 'Text', width: '100px', center: true },
              { id: 4, header: 'Fecha', element: 'Text', width: '120px', center: true },
              { id: 5, header: '', element: 'Text', width: '60px' },
            ]}
            rows={5}
          />
        </TableContainer>
      )
    }

    if (!documents || documents.length === 0) {
      return (
        <TableContainer>
          <Table
            curvedBottom
            withBorder
            roundedCorners
            data={[{ id: 'empty' }]}
            columns={[
              {
                Header: function () { return <TableHeader blue title='Nombre' /> },
                id: 'name',
                accessor: function () { return null },
                Cell: function () { return null }
              },
              {
                Header: function () { return <TableHeader blue center title='Tipo' /> },
                id: 'mime_type',
                accessor: function () { return null },
                width: 100,
                Cell: function () { return null }
              },
              {
                Header: function () { return <TableHeader blue center title='Tamaño' /> },
                id: 'file_size',
                accessor: function () { return null },
                width: 100,
                Cell: function () { return null }
              },
              {
                Header: function () { return <TableHeader blue center title='Fecha' /> },
                id: 'sent_at',
                accessor: function () { return null },
                width: 120,
                Cell: function () { return null }
              },
              {
                Header: function () { return <TableHeader blue /> },
                id: 'actions',
                accessor: function () { return null },
                width: 60,
                Cell: function () { return null }
              }
            ]}
          />
          <NoResults>No hay documentos en el repositorio</NoResults>
        </TableContainer>
      )
    }

    return (
      <TableContainer>
        <Table
          curvedBottom
          withBorder
          roundedCorners
          data={documents}
          columns={[
            {
              Header: function () { return <TableHeader blue title='Nombre' /> },
              id: 'name',
              accessor: function (row) { return row.document_name || row.name || '-' },
              Cell: function (props) {
                return <LeftCell index={props.index}>{props.value}</LeftCell>
              }
            },
            {
              Header: function () { return <TableHeader blue center title='Tipo' /> },
              id: 'mime_type',
              accessor: 'mime_type',
              width: 100,
              Cell: function (props) {
                return <CellContainer index={props.index}>{self.formatMimeType(props.value)}</CellContainer>
              }
            },
            {
              Header: function () { return <TableHeader blue center title='Tamaño' /> },
              id: 'file_size',
              accessor: 'file_size',
              width: 100,
              Cell: function (props) {
                return <CellContainer index={props.index}>{self.formatFileSize(props.value)}</CellContainer>
              }
            },
            {
              Header: function () { return <TableHeader blue center title='Fecha' /> },
              id: 'sent_at',
              accessor: 'sent_at',
              width: 120,
              Cell: function (props) {
                var val = props.value
                if (!val) return <CellContainer index={props.index}>-</CellContainer>
                var dateStr = (val && val.date) ? val.date : val
                var parsed = moment(dateStr)
                return (
                  <CellContainer index={props.index}>
                    {parsed.isValid() ? parsed.format('DD-MM-YYYY') : '-'}
                  </CellContainer>
                )
              }
            },
            {
              Header: function () { return <TableHeader blue /> },
              id: 'actions',
              accessor: function (row) { return { id: row.id, name: row.document_name || row.name || '' } },
              width: 60,
              Cell: function (props) {
                var elements = [
                  {
                    id: 1,
                    icon: 'download',
                    label: 'Descargar',
                    onClick: function () { self.handleDownload(props.value.id) }
                  }
                ]
                if (canDelete) {
                  elements.push({
                    id: 2,
                    icon: 'remove',
                    label: 'Eliminar',
                    onClick: function () { self.openDeleteModal(props.value) }
                  })
                }
                return (
                  <CellContainer index={props.index}>
                    <ContextMenu
                      value={props.value.id}
                      elements={elements}
                    />
                  </CellContainer>
                )
              }
            }
          ]}
        />
      </TableContainer>
    )
  }

  render () {
    var meta = this.props.meta
    var deleting = this.props.deleting
    var documentToDelete = this.state.documentToDelete

    return (
      <Container>
        {/*<HeaderRow>
          <Title>Documentos del Alumno</Title>
          <Button primary small onClick={this.handleSendDocument}>
            Enviar Documento
          </Button>
        </HeaderRow>*/}

        <SearchRow onSubmit={this.handleSearch}>
          <InputWrapper>
            <TextInput
              name='search'
              label='Buscar documento'
              value={this.state.search}
            />
          </InputWrapper>
          <SearchButton>
            <Button primary small type='submit' loading={this.props.fetching}>
              Buscar
            </Button>
          </SearchButton>
        </SearchRow>

        <PaginationContainer>
          <Pagination
            totalElements={meta ? meta.total : 0}
            elementsPerPage={meta ? meta.per_page : 20}
            onPageClick={this.handlePageClick}
            pageSelected={this.state.page}
          />
        </PaginationContainer>

        {this.renderTable()}

        <DeleteConfirmationModal
          isOpen={this.state.deleteModalOpen}
          onClose={this.closeDeleteModal}
          onConfirm={this.confirmDelete}
          documentName={documentToDelete ? documentToDelete.name : ''}
          deleting={deleting}
        />
      </Container>
    )
  }
}

StudentDocumentRepository.propTypes = {
  studentId: PropTypes.number.isRequired,
  documents: PropTypes.array,
  meta: PropTypes.object,
  fetching: PropTypes.bool,
  deleting: PropTypes.bool,
  userRole: PropTypes.string,
  user: PropTypes.object,
  fetchStudentDocuments: PropTypes.func.isRequired,
  deleteDocument: PropTypes.func.isRequired,
  downloadDocument: PropTypes.func.isRequired,
  openWizard: PropTypes.func.isRequired
}

StudentDocumentRepository.defaultProps = {
  documents: [],
  meta: null,
  fetching: false,
  deleting: false,
  userRole: '',
  user: {}
}

var mapStateToProps = function (state) {
  return {
    documents: state.documents.studentRepository.documents,
    meta: state.documents.studentRepository.meta,
    fetching: state.documents.studentRepository.fetching,
    deleting: state.documents.delete.fetching,
    userRole: state.auth.user.role,
    user: state.auth.user
  }
}

var mapDispatchToProps = function (dispatch) {
  return {
    fetchStudentDocuments: function (studentId, filters) {
      return dispatch(DocumentsActions.fetchStudentDocumentsRequest(studentId, filters))
    },
    deleteDocument: function (studentId, documentId) {
      return dispatch(DocumentsActions.deleteStudentDocumentRequest(studentId, documentId))
    },
    downloadDocument: function (studentId, documentId) {
      return dispatch(DocumentsActions.downloadStudentDocumentRequest(studentId, documentId))
    },
    openWizard: function (documentId, studentId) {
      return dispatch(DocumentsActions.openWizard(documentId, studentId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentDocumentRepository)



// WEBPACK FOOTER //
// ./src/Containers/Documents/StudentDocumentRepository/index.jsx